import * as React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { addCodeRedToQuote, setQuoteData } from '../../../../actions/salesActions';
import KPInputTextArea from '../../../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import { postToController } from '../../../../actions/apiActions';
import { IDropdownData } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';
import KPDropdown from '../../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import { SALES_CHAT_LOADING_SCREEN_SHOW, SALES_CHAT_LOADING_SCREEN_HIDE } from '../../../../constants/constants';
import './CodeRedSearchVehicle.css'

class CodeRedSearchVehicle extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            submitted: false,
            nextDisabled: true,
            editYear: this.props.sales.vehicleYear,
            yearsDropdownOpen: false,
            selectedItem: this.props.sales.vehicleFullDescription ? { fullDescription: this.props.sales.vehicleFullDescription } : "",
            cursor: 0,
            searchItems: [],
            yearList: [],
            carColourList: [],
            selectedCarColour: this.props.sales.carColor,
            selectedCarColourDescription: "",
            selectedCarColourDropdown: false,
            buttonYesClicked: false,
            buttonNoClicked: false,
            regNr: this.props.sales.regNr,
            vehicleMakeId: this.props.sales.vehicleMakeId,
            vehicleModelId: this.props.sales.vehicleModelId,
            vehicleSeriesId: this.props.sales.vehicleSeriesId,
            mmCode: this.props.sales.mmCode,
            riskItemSelect: (this.props.sales.codeRedSelectedRiskitem && this.props.sales.codeRedSelectedRiskitem != "0") ? true : false,
        };

        this.autocomplete = this.autocomplete.bind(this);
        this.hanldeKeyup = this.hanldeKeyup.bind(this);
        this.hanldeKeydown = this.hanldeKeydown.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleYearsDropdownToggle = this.handleYearsDropdownToggle.bind(this);
        this.handleYearsSelection = this.handleYearsSelection.bind(this);
        this.handleCarColorSelection = this.handleCarColorSelection.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        await this.checkSubmit();
    }

    async componentDidMount() {
        await this.props.dispatchAction({ type: SALES_CHAT_LOADING_SCREEN_SHOW })
        if (this.state.yearList.length === 0) {
            await this.getYearList();
        }

        if (this.state.carColourList.length === 0) {
            await this.getcarColourList();
        }

        try {
            if (this.props.sales.carColor) {
                await this.setState({
                    selectedCarColour: this.props.sales.carColor,
                    selectedCarColourDescription: this.props.sales.carColor.description
                })
            }
        } catch {
            await this.setState({
                selectedCarColour: "",
                selectedCarColourDescription: ""
            })
        }
        if (this.props.sales.codeRedSelectedRiskitem && this.props.sales.codeRedSelectedRiskitem != "0") {
            await postToController(this.props.dispatch, 'GetCarDetails', JSON.stringify({
                QuoteId: this.props.sales.quoteId,
                RiskItemId: this.props.sales.codeRedSelectedRiskitem,
                QuoteRiskItemId: this.props.sales.codeRedSelectedRiskitem
            })).then(async (carDetailsResponse) => {
                let selectedColour = this.state.carColourList.filter(function (item) {
                    return item.id == carDetailsResponse.carDetails.carDetails.carColour
                })
                await this.setState({
                    vehicleMakeId: carDetailsResponse.carDetails.carDetails.vehicleMakeId,
                    vehicleModelId: carDetailsResponse.carDetails.carDetails.vehicleModelId,
                    vehicleSeriesId: carDetailsResponse.carDetails.carDetails.vehicleSeriesId,
                    mmCode: carDetailsResponse.carDetails.carDetails.mmCode,
                    selectedCarColour: selectedColour.length > 0 ? selectedColour[0] : selectedColour,
                    selectedCarColourDescription: selectedColour.length > 0 ? selectedColour[0].description : "",
                    selectedItem: carDetailsResponse.carDetails.carDetails.description ? { fullDescription: carDetailsResponse.carDetails.carDetails.description } : "",
                    editYear: carDetailsResponse.carDetails.carDetails.year.toString(),
                    regNr: carDetailsResponse.carDetails.carDetails.registrationNumber,
                    riskItemSelect: true,
                }, () => this.checkSubmit());
            });
        }
        else {
            await this.setState({
                vehicleMakeId: this.props.sales.vehicleMakeId,
                vehicleModelId: this.props.sales.vehicleModelId,
                vehicleSeriesId: this.props.sales.vehicleSeriesId,
                mmCode: this.props.sales.mmCode,
                selectedCarColour: this.props.sales.carColor,
                selectedCarColourDescription: this.props.sales.carColor.description,
                selectedItem: this.props.sales.vehicleFullDescription ? { fullDescription: this.props.sales.vehicleFullDescription } : "",
                editYear: this.props.sales.vehicleYear,
                regNr: this.props.sales.regNr,
                riskItemSelect: false,
            })
        }
        await this.props.dispatchAction({ type: SALES_CHAT_LOADING_SCREEN_HIDE })
    }

    async autocomplete(evt) {
        let text = evt.target.value;
        var listmax = 50;   //Make the search quicker - can't return full list
        var items = [];
        await this.setState({ selectedItem: text });
        await this.setState({ searchItems: [] });

        if (text && text.length >= 3 && this.state.editYear !== "") {
            await postToController(this.props.dispatch, 'VehicleSearch', JSON.stringify({ Year: parseInt(this.state.editYear), SearchText: text }))
                .then(async (response) => {
                    if (response !== "Failure") {
                        items = response
                            .filter((i, index) => (index < listmax))
                            .map((i, index) => {
                                return (
                                    i
                                );
                            });

                        await this.setState({ searchItems: items });
                    }
                });
        }
        await this.checkSubmit();
    }

    hanldeKeyup(evt) {
        if (evt.keyCode === 27) {
            this.setState({ searchItems: [] });
            return false;
        }
    }

    hanldeKeydown(evt) {
        const { cursor, searchItems } = this.state;
        // arrow up/down button should select next/previous list element
        if (evt.keyCode === 38 && cursor > 0) {
            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }));
        } else if (evt.keyCode === 40 && cursor < searchItems.length - 1) {
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }));
        }
        if (evt.keyCode === 13) {
            let currentItem = searchItems[cursor];
            if (currentItem !== undefined) {
                this.setState({ searchItems: [] });
            }
        }
    }

    async selectItem(item) {
        await this.setState({ selectedItem: item, vehicleMakeId: item.vehicleMake.id, vehicleModelId: item.vehicleModel.id, vehicleSeriesId: item.vehicleSeries.id, mmCode: item.vehicleSeries.mmCode });
        await this.setState({ searchItems: [] });
        await this.checkSubmit();
    }

    async handleYearsSelection(year: any) {
        await this.setState({ editYear: year });
        await this.checkSubmit();
    }

    async handleCarColorSelection(colour: any) {
        let selectedColour = this.state.carColourList.filter(function (item) {
            return item.id == colour
        })
        await this.setState({ selectedCarColour: selectedColour[0], selectedCarColourDescription: selectedColour[0].description });
        await this.checkSubmit();
    }

    async handleYearsDropdownToggle(e: any) {
        await this.setState({
            yearsDropdownOpen: !this.state.yearsDropdownOpen
        });
    }


    async getYearList() {
        let result: string[] = [];
        var currentYear = new Date().getFullYear() - 1, years = [];
        var startYear = currentYear - 20;

        while (startYear <= currentYear) {
            startYear++
            result.push(startYear.toString());
        }
        await this.setState({ yearList: result.reverse() });
    }

    async getcarColourList() {
        await postToController(this.props.dispatch, 'GetCarColours', JSON.stringify({}))
            .then(async (response) => {
                if (response) {
                    await this.setState({ carColourList: response });
                }
            });
    }

    async checkSubmit() {
        if (this.state.editYear && this.state.selectedItem && this.state.selectedCarColour && this.state.regNr) {
            await this.setState({ nextDisabled: false });
        } else {
            await this.setState({ nextDisabled: true });
        }
    }

    async handleSwitch(e: any) {
        //var checked = e.target.checked;
        //await this.setState({ desktopTCs: checked });
        await this.checkSubmit();
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    async handleClick() {
        await this.checkSubmit();
        if (!this.state.nextDisabled) {
            let payload = {
                carColor: this.state.selectedCarColour,
                vehicleFullDescription: this.state.selectedItem.fullDescription,
                vehicleYear: this.state.editYear,
                vehicleMakeId: this.state.vehicleMakeId,
                vehicleSeriesId: this.state.vehicleSeriesId,
                vehicleModelId: this.state.vehicleModelId,
                regNr: this.state.regNr,
                mmCode: this.state.mmCode,
            }
            await this.props.dispatchAction(setQuoteData(payload));
            await this.props.dispatchAction(addCodeRedToQuote());
        }
    }

    public render() {
        let yearDrop = [];
        if (this.state.yearList.length > 0) {
            yearDrop = this.state.yearList.map(item => {
                return ({
                    description: item,
                    id: item,
                    productName: ""
                }) as IDropdownData;
            });
        }

        let colorDrop = [];
        if (this.state.carColourList.length > 0) {
            colorDrop = this.state.carColourList.map(item => {
                return ({
                    description: item.description,
                    id: item.id,
                    productName: ""
                }) as IDropdownData;
            });
        }

        const { submitted } = this.state;
        return (
            <div className="container expand-dropdown">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-12">
                        <div className="mt-21px mobile-mt-17px mb-40px">
                            {this.state.riskItemSelect &&
                                <p className="mt-4 mb-1 text-center Lets-get-to-know-ea">Confirm your car details</p>
                            }
                            {!this.state.riskItemSelect &&
                                <p className="mt-4 mb-1 text-center Lets-get-to-know-ea">Please tell us a bit about your car.</p>
                            }
                        </div>
                        <div className="form-row mb-lg-1 mb-20px mobile-mb-0px">
                            <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                                {this.state.riskItemSelect &&
                                    <>
                                        <label className={'left-align temp-text-box-label pl-1' + (this.state.editYear !== "" ? "" : " no-opacity")}>Year</label>
                                        <input
                                            type="text"
                                            id="carYear"
                                            value={this.state.editYear}
                                            className="custom-input form-control"
                                            placeholder="Year"
                                            disabled={true}
                                        />

                                        {this.state.selectedItem === "" && this.state.submitted &&
                                            <div className="help-block mt-0">Year is required</div>
                                        }
                                    </>
                                }
                                {!this.state.riskItemSelect &&
                                    <KPDropdown
                                        id={"car-year"}
                                        isImageDropdown={false}
                                        showLabelAfterSelection={true}
                                        showLabelInside={false}
                                        showLabelOutside={true}
                                        isRiskItem={false}
                                        labelAfterSelection={"Year"}
                                        title={"Year"}
                                        label={"Year"}
                                        data={yearDrop}
                                        handleSelection={(e) => this.handleYearsSelection(e)}
                                        selectedValue={this.state.editYear}
                                        disabled={this.state.riskItemSelect}
                                        className={"ssp-sales-journey-dropdown"}
                                    />
                                }
                            </div>
                            <div className="col-12 col-lg-6">
                                <label className={'left-align temp-text-box-label pl-1' + (this.state.selectedItem !== "" ? "" : " no-opacity")}>Make and model</label>
                                <input
                                    type="text"
                                    id="autocomplete"
                                    onChange={this.autocomplete}
                                    onKeyUp={this.hanldeKeyup}
                                    onKeyDown={this.hanldeKeydown}
                                    value={this.state.selectedItem.fullDescription}
                                    className="custom-input form-control"
                                    placeholder="Make and model"
                                    disabled={this.state.riskItemSelect}
                                />
                                {this.state.searchItems.length > 0 && (
                                    <div id="makeAndModelCodeRed">
                                        <ul className="list-group">
                                            {this.state.searchItems.map((item, idx) => (
                                                <li
                                                    className={
                                                        this.state.cursor === idx ? "active list-group-item" : "list-group-item"
                                                    }
                                                    key={idx}
                                                    onClick={() => this.selectItem(item)}
                                                >
                                                    {item.fullDescription}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                            </div>
                            {this.state.selectedItem === "" && this.state.submitted &&
                                <div className="help-block mt-0">Make and model is required</div>
                            }
                        </div>
                        <div className="form-row">
                            <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                                <KPDropdown
                                    id={"car-color"}
                                    isImageDropdown={false}
                                    showLabelAfterSelection={true}
                                    showLabelInside={false}
                                    showLabelOutside={true}
                                    isRiskItem={false}
                                    labelAfterSelection={"Colour"}
                                    title={"Colour"}
                                    label={"Colour"}
                                    data={colorDrop}
                                    handleSelection={(e) => this.handleCarColorSelection(e)}
                                    selectedValue={this.state.selectedCarColourDescription}
                                    className={"ssp-sales-journey-dropdown"}
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <KPInputTextArea
                                    id="CarRegistration"
                                    name="regNr"
                                    type="input"
                                    className="mb-15px"
                                    label={"Reg no."}
                                    alwaysShowLabel={false}
                                    value={this.state.regNr}
                                    notice={(submitted && !this.state.regNr)}
                                    noticeType={"error"}
                                    noticeMessage={"Whoops, we require your regstration number"}
                                    successTick={false}
                                    required={true}
                                    readOnly={false}
                                    autoFocus={false}
                                    minLength={3}
                                    maxLength={false}
                                    disabled={false}
                                    form="mainform"
                                    handleChange={(e) => this.handleChange(e)}
                                />
                            </div>
                        </div>
                        <div className="justify-content-center mt-20px">
                            <div className="sales-button-holder">
                                <Button className="btn btn-solid-red button-sales-height" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Submit</Button>
                            </div>
                        </div>
                        <div className="please-note-code-red mt-40px">
                            <p className="mb-2px font-weight-bold ml-20px mb-5px">Please note</p>
                            <ul className="text-left">
                                <li className="noma nopa">By submitting this info, you're not changing any details on your policy. (This will help our emergency responders to identify you, in case of an emergency.)</li>
                                <li className="noma nopa">To update your policy details, simply <b>WhatsApp</b> us on 0860 50 50 50.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CodeRedSearchVehicle);